/**
 * 查询模板类型
 */

import request from '@/utils/request'

// /**
//  * 登录
//  * @param data
//  */
// export function templateSelectTemplate(data) {
//   return request({
//     url: '/template/selectTemplate',
//     method: 'post',
//     data
//   })
// }

// /**
//  * 查询模板文件（查询使用）
//  * @param data
//  */
// export function templateSelectTemplateFile(data) {
//   return request({
//     url: '/template/selectTemplateFile',
//     method: 'post',
//     data
//   })
// }

// /**
//  * 查询模板文件（查询使用）
//  * @param data
//  */
// export function templateInsert(data) {
//   return request({
//     url: '/template/insert',
//     method: 'post',
//     data
//   })
// }

// /**
//  * 删除模版集合
//  * @param data
//  */
// export function templateDelete(data) {
//   return request({
//     url: '/template/delete',
//     method: 'post',
//     data
//   })
// }

// /**
//  * 删除模版文件
//  * @param data
//  */
// export function templateDeleteTemplateFile(data) {
//   return request({
//     url: '/template/deleteTemplateFile',
//     method: 'post',
//     data
//   })
// }

// /**
//  * 删除模版文件
//  * @param data
//  */
// export function templateUpdate(data) {
//   return request({
//     url: '/template/update',
//     method: 'post',
//     data
//   })
// }

// /**
//  * 上传
//  * @param data
//  */
// export function templateUploadTemplateFile(data) {
//   return request({
//     url: '/template/uploadTemplateFile',
//     method: 'post',
//     data
//   })
// }

/**
 * 上传
 * @param data
 */
export function commonFileUpload(data) {
  return request({
    url: '/common/file/upload',
    method: 'post',
    timeout:300000,
    data
  })
}

/**
 * 加载目录树
 * @param {*} data 
 */
export function folderTree(data){
  return request({
    url:'/folder/select/asTree',
    method:'post',
    data
  })
}

/**
 * 添加子目录
 * @param {*} data 
 */
export function addSubFolder(data){
  return request({
    url:'/folder/add',
    method:'post',
    data
  })
}

/**
 * 更新目录属性
 * @param {*} data 
 */
export function updateFolder(data){
  return request({
    url:'/folder/update',
    method:'post',
    data
  })
}

/**
 * 批量删除文件夹
 * @param {Array} data ids文件夹ids
 */
export function deleteFolders(data){
  return request({
    url:'/folder/batch/delete',
    method:'post',
    data
  })
}

/**
 * 批量删除文件
 * @param {*} data ids文件ids
 */
export function deleteFiles(data){
  return request({
    url:'/folder/file/batch/delete',
    method:'post',
    data
  })
}

/**
 * 提交上传文件
 * @param {*} data 
 */
export function addFile(data){
  return request({
    url:'/folder/file/add',
    method:'post',
    data
  })
}

/**
 * 文件列表
 * @param {*} data 
 */
export function fileList(data){
  return request({
    url:'/folder/file/select/page',
    method:'post',
    data
  })
}

/**
 * 文件下载
 * @param {*} fileId 
 */
export function fileDownload(fileId){
  return request({
    url:'/folder/file/view/id',
    method:'post',
    responseType:"blob",
    timeout:300000,
    data:{id:fileId}
  })
}

/**
 * 根据url查询文件信息
 * @param {*}} url 
 */
export function fileInfo(data){
  return request({
    url:'/folder/file/select/showUrl',
    method:'post',
    data
  })
}

/**
 * 文件下载 checklist 使用
 * @param {*} url 
 */
export function fileDownloadByInnerUrl(url){
  return request({
    url:'/folder/file/view/showUrl',
    method:'post',
    responseType:"blob",
    timeout:300000,
    data:{fileShowUrl:url}
  })
}



/**
 * 根据url查询文件信息
 * @param {*}} url 
 */
export function FolderFileNameExist(data){
  return request({
    url:'/folder/file/name/exist',
    method:'post',
    data
  })
}